import { Middleware } from "@nuxt/types";
import { usePageStore } from "~/stores/page";
import { Logger } from "~/helpers/logger";
import { RoutableInterface } from "~/modules/GraphQL/types";
import skipPaths from "./skipPaths";

const urlResolverMiddleware: Middleware = async (context) => {
  const pageStore = usePageStore();
  const { path } = context.route;

  let clearUrl = path.replace(/[a-z]+\/[cp|]\//gi, "").replace(`/${context.i18n.locale}`, "");

  // If this is a CMS page with /cms/ prefix, remove it for API call
  if (path.startsWith("/cms/")) {
    clearUrl = path.replace("/cms/", "/").replace(`/${context.i18n.locale}`, "");
  }

  Logger.debug("middleware/url-resolver", clearUrl);

  const shouldSkip = skipPaths.includes(clearUrl);

  if (shouldSkip) {
    Logger.debug("middleware/url-resolver", `Skipping URL resolver for path: ${clearUrl}`);
    return;
  }

  const { data, errors } = await context.app.$vsf.$magento.api.route(clearUrl);

  Logger.debug("middleware/url-resolver/result", { data, errors });

  const results: RoutableInterface | null = data?.route ?? null;

  if (!results || errors?.length) context.error({ statusCode: 404 });

  pageStore.$patch((state) => {
    state.routeData = results;
  });
};

export default urlResolverMiddleware;
